export const ROLES_KEY = 'roles';
export const getRolesKey = (args) => [ROLES_KEY, args];
//# sourceMappingURL=roles.key.js.map